import { render, staticRenderFns } from "./LessonsPage.vue?vue&type=template&id=95f29dfc&scoped=true&"
import script from "./LessonsPage.vue?vue&type=script&lang=js&"
export * from "./LessonsPage.vue?vue&type=script&lang=js&"
import style0 from "./LessonsPage.vue?vue&type=style&index=0&id=95f29dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f29dfc",
  null
  
)

export default component.exports